"use client";

import { c as _c } from "react/compiler-runtime";
import { getMediaGatewayFallbackUrls } from "@/components/nft-image/utils/gateway-fallback";
import { useMemo, useState } from "react";
type GatewayImageLoadMode = "optimized" | "unoptimized" | "placeholder";
type GatewayImageLoadState = {
  src: string | null;
  candidateIndex: number;
  mode: GatewayImageLoadMode;
};
export function useGatewayImageLoadState(t0) {
  const $ = _c(16);
  const src = t0 === undefined ? null : t0;
  const normalizedSrc = src;
  let t1;
  if ($[0] !== normalizedSrc) {
    t1 = normalizedSrc ? getMediaGatewayFallbackUrls(normalizedSrc) : [];
    $[0] = normalizedSrc;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const candidateUrls = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      src: null,
      candidateIndex: 0,
      mode: "optimized"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [loadState, setLoadState] = useState(t2);
  let t3;
  if ($[3] !== loadState || $[4] !== normalizedSrc) {
    t3 = loadState.src === normalizedSrc ? loadState : {
      src: normalizedSrc,
      candidateIndex: 0,
      mode: "optimized"
    };
    $[3] = loadState;
    $[4] = normalizedSrc;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const currentState = t3;
  const activeSrc = candidateUrls[currentState.candidateIndex] ?? null;
  const isPlaceholder = normalizedSrc === null || activeSrc === null || currentState.mode === "placeholder";
  let t4;
  if ($[6] !== candidateUrls.length || $[7] !== currentState.candidateIndex || $[8] !== currentState.mode || $[9] !== normalizedSrc) {
    t4 = () => {
      if (normalizedSrc === null) {
        return;
      }
      if (currentState.mode === "optimized") {
        setLoadState({
          src: normalizedSrc,
          candidateIndex: currentState.candidateIndex,
          mode: "unoptimized"
        });
        return;
      }
      if (currentState.candidateIndex + 1 < candidateUrls.length) {
        setLoadState({
          src: normalizedSrc,
          candidateIndex: currentState.candidateIndex + 1,
          mode: "optimized"
        });
        return;
      }
      setLoadState({
        src: normalizedSrc,
        candidateIndex: currentState.candidateIndex,
        mode: "placeholder"
      });
    };
    $[6] = candidateUrls.length;
    $[7] = currentState.candidateIndex;
    $[8] = currentState.mode;
    $[9] = normalizedSrc;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const handleError = t4;
  const t5 = currentState.mode === "unoptimized";
  let t6;
  if ($[11] !== activeSrc || $[12] !== handleError || $[13] !== isPlaceholder || $[14] !== t5) {
    t6 = {
      activeSrc,
      isPlaceholder,
      unoptimized: t5,
      handleError
    };
    $[11] = activeSrc;
    $[12] = handleError;
    $[13] = isPlaceholder;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}